import { aaiApi } from '../../services/aaiApi';
import { useAsync } from '../aai/useAsync';
import type { DepartmentOverview } from '../../types/aai';

/*
 * The one read every Department Head page makes. The server resolves which
 * department the caller leads and filters everything to it, so no page here
 * asks for a department by name.
 */
export const useDepartment = () => useAsync<DepartmentOverview>(
  () => aaiApi.getDepartmentOverview(),
  'Could not load your department.',
);

export const departmentName = (overview: DepartmentOverview | null): string => overview?.department.name || 'Your department';

export const plural = (n: number, one: string, many: string): string => `${n} ${n === 1 ? one : many}`;

export const hours = (minutes: number): string => {
  const h = minutes / 60;
  if (h >= 100) return `${Math.round(h)}h`;
  return `${Math.round(h * 10) / 10}h`;
};

export const money = (amount: number): string => {
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(amount);
  } catch {
    return `$${Math.round(amount)}`;
  }
};
